<template>
  <dashboard-tile class="h-100">
    <h6 class="dashboard-tile-title border-bottom p-3 mb-0">{{ $t('flexigo.dashboard.rideRequests') }}</h6>
    <div class="p-3">
      <div
        v-for="(group, groupIndex) in groups"
        :key="group.workingTypes"
        :class="{ 'mb-4': groupIndex < groups.length - 1 }"
      >
        <h6 class="fw-semibold mb-3">{{ group.title }}</h6>
        <div
          v-for="(row, rowIndex) in group.rows"
          :key="rowIndex"
          class="row gx-2"
          :class="{ 'mb-2': rowIndex < group.rows.length - 1 }"
        >
          <div v-for="box in row" :key="box.requestType" class="col">
            <dashboard-count-box
              class="p-4"
              :value="value[box.field]"
              :label="box.label"
              @open="direct({ workingTypes: group.workingTypes, requestType: box.requestType })"
            />
          </div>
        </div>
      </div>
    </div>
  </dashboard-tile>
</template>

<script>
import DashboardTile from './DashboardTile.vue';
import DashboardCountBox from './DashboardCountBox.vue';

export default {
  name: 'RideRequests',
  components: { DashboardTile, DashboardCountBox },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // Each count opens Reservations filtered to its working type and request type(s).
    groups() {
      return [
        {
          title: this.$t('flexigo.workgroup.dynamic'),
          workingTypes: 'DYNAMIC',
          rows: [
            [
              { field: 'dynamicReceived', requestType: 'REQUESTED', label: this.$t('flexigo.employeeList.received') },
              { field: 'dynamicReserved', requestType: 'RESERVED', label: this.$t('flexigo.dashboard.reserved') },
            ],
            [
              {
                field: 'dynamicFailed',
                requestType: 'NOT_SERVICED',
                label: this.$t('flexigo.routeList.planningStatusOptions.NOT_SERVICED'),
              },
              {
                field: 'dynamicNotFulfilled',
                requestType: 'NOT_FULFILLED',
                label: this.$t('flexigo.routeList.planningStatusOptions.NOT_FULFILLED'),
              },
              { field: 'dynamicCanceled', requestType: 'CANCELLED', label: this.$t('flexigo.dashboard.canceled') },
            ],
          ],
        },
        {
          title: this.$t('flexigo.workgroup.fixed'),
          workingTypes: 'FIXED',
          rows: [
            [
              { field: 'fixedReserved', requestType: 'RESERVED,REGULAR', label: this.$t('flexigo.dashboard.reserved') },
              { field: 'fixedCanceled', requestType: 'CANCELLED', label: this.$t('flexigo.dashboard.canceled') },
            ],
          ],
        },
      ];
    },
  },
  methods: {
    direct(options) {
      const queries = { ...this.$route.query, ...options, ...{ workgroupType: 'SHUTTLE' } };
      const routeData = this.$router.resolve({ name: 'Reservations', params: { type: 'SHUTTLE' }, query: queries });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
